import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import CopyToClipboard from 'react-copy-to-clipboard';


function DriverList(){
    let navigate = useNavigate();
    const location = useLocation();
    const{headers1,headers2,logout}=AuthUser();
    const [list, setList] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    const [SearchType, setSearchType] = useState('Any');
    const [SearchVal, setSearchVal] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1); // Total number of pages
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [prevPageUrl, setPrevPageUrl] = useState(null);
    const pageRangeDisplayed = 2; 

    useEffect(()=>{
        const query = new URLSearchParams(location.search);
        const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
        const search = query.get('search') || '';
        setCurrentPage(page);
        setSearchVal(search);
        GetDriverList(page,search);
    },[location.search]);
    const GetDriverList=(page=1,type,val)=>{
        setSubloading(true);
        setSearchVal(val);
        axios({
            method: 'post',
            url: Global.baseUrl+'FetchDriver',
            headers:headers1,
            data: {
                SearchType:SearchType,
                SearchVal:SearchVal,
                page:page
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setCurrentPage(response.data.value.current_page);
                setLastPage(response.data.value.last_page);
                setNextPageUrl(response.data.value.next_page_url); // URL for next page
                setPrevPageUrl(response.data.value.prev_page_url); // URL for previous page
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
          });
    }
    const SearchCust=(e)=>{
        setSearchVal(e);
        GetDriverList();
    }
    const handleStatus=(index)=>{
        const newList = [...list];
        let newValue="";
        if(newList[index]['status']=='Y'){
            newValue='N';
        }else{
            newValue='Y';
        }
        newList[index]['status'] = newValue;
        setList(newList);

        axios({
            method: 'post',
            url: Global.baseUrl+'UpdateDriverStatus',
            headers:headers1,
            data: {
                id:newList[index]['id'],
                value:newValue
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                toast.success(response.data.message);
            }
            else
            {
                toast.error(response.data.message);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            // console.log(error);
          });
    }
    const handleDelete=(id)=>{
        if(window.confirm("Do You Really Want To Delete")){
            axios({
                method: 'post',
                url: Global.baseUrl+'DeleteDriver',
                headers:headers1,
                data: {
                    id:id,
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                }
                else
                {
                    toast.error(response.data.message);
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    // logout();
                    // navigate('/');
                    // window.location.reload();
                }
                // console.log(error);
              });
        }
        GetDriverList();
    }
    // Update the URL and fetch the data for the selected page
 const handlePageChange = (pageNumber) => {
    const query = new URLSearchParams(location.search);
    query.set('page', pageNumber);
    navigate(`?${query.toString()}`);
  };
  const handleSearchChange = (event) => {
    setSearchVal(event.target.value);
  };
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = new URLSearchParams(location.search);
    query.set('search', SearchVal);
    query.set('page', 1); // Reset to page 1 on a new search
    navigate(`?${query.toString()}`);
  };
  // Handle Previous button click
  const handlePreviousPage = () => {
    if (prevPageUrl) {
      handlePageChange(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNextPage = () => {
    if (nextPageUrl) {
      handlePageChange(currentPage + 1);
    }
  };

// Create pagination items for each page, showing a limited number of page numbers with ellipses
const renderPageNumbers = () => {
    const pages = [];

    // Always show the first page
    if (currentPage > pageRangeDisplayed + 1) {
      pages.push(
        <li key={1} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
        </li>
      );
      pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
    }

    // Show the range of pages around the current page
    for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
      pages.push(
        <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    // Always show the last page
    if (currentPage < lastPage - pageRangeDisplayed) {
      pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
      pages.push(
        <li key={lastPage} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
        </li>
      );
    }

    return pages;
  };
    return(
        <>
        <UserLeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true?<MainLoader/>:
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="#">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Drivers</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button">
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">All Drivers</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="dropdown">
                        <button className="btn btn-primary d-inline-flex align-items-center me-2 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <svg className="icon icon-xs me-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                            New 
                        </button>
                        <div className="dropdown-menu dashboard-dropdown dropdown-menu-start mt-2 py-1">
                            <Link className="dropdown-item d-flex align-items-center" to={`/DriverAdd`}>
                                <i className="bx bx-cube text-primary-400 me-2 fs-5"></i>
                                Add New Driver
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md"></div>
                <div className="col-12 col-md-4">
                    <div className="table-settings shipment_list" id="">
                        <div className="row align-items-start g-2" >
                            <div className="col col-md ">
                            <form onSubmit={handleSearchSubmit}>
                                    <div className="input-group ">
                                        <select className="form-select" onChange={(e)=>setSearchType(e.target.value)}>
                                            <option value="Any">Any</option>
                                            <option value='Name'>Name</option>
                                            <option value='Email'>Email</option>
                                            <option value='Phone'>Mobile Number</option>
                                        </select>
                                        <input type="text" className="form-control w-50" placeholder="Search Drive" onChange={handleSearchChange} />
                                        <button type="submit" className="input-group-text">
                                            <i className="bx bx-search"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            

            

            

            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200" style={{"width":"20px"}}>
                                    <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="" />
                                </th>						
                                <th className="border-gray-200">Driver Code #</th>
                                <th className="border-gray-200">name</th>
                                <th className="border-gray-200">Phone</th>
                                <th className="border-gray-200">Email</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Action</th>
                            </tr>
                        </thead>
                        {Subloading==true && <ListLoader/>}
                        {list!=undefined && list.length>0 && Subloading==false ?
                        <tbody>
                            {list.map((item,index)=>{
                                return(
                                    <tr key={index}>
                                <td style={{"width":"20px"}}>
                                    <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="" />
                                </td>
                                <td>
                                    <div>
                                        <Link to={`/DriverEdit/${item.id}`} className="fw-bold">{item.messenger_code}</Link>
                                        <CopyToClipboard text={item.messenger_code} onCopy={()=>{toast.success(item.messenger_code+' Copied To Clipboard')}}>
                                            <i className="bx bx-copy"></i>
                                        </CopyToClipboard>
                                    </div>
                                </td>
                                <td><span className="fw-normal text-capitalize">{item.messenger_name}</span></td>
                                <td><span className="fw-normal text-capitalize">{item.mobile}</span></td>
                                <td><span className="fw-normal text-capitalize">{item.email}</span></td>
                                <td>
                                    <div className="form-check form-switch  mb-2">
                                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={item.status=='Y'?true:false} onChange={()=>handleStatus(index)} />
                                    </div>
                                </td>
                                <td>
                                    {/* <a href="#" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="View Profile"><i className="bx bx-user"></i></a> */}
                                    <Link to={`/DriverEdit/${item.id}`} className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="Edit"><i className="bx bx-edit"></i></Link>
                                    <button onClick={()=>handleDelete(item.id)} type="button" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="Delete"><i className="bx bx-x"></i></button>
                                </td>
                            </tr>
                            );
                        })}                     
                    </tbody>
                    :
                    <tbody><tr><td colSpan={8}> Record Not Found </td></tr></tbody>
                    }
                    </table>
                    
                </div>
            </section>
            <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul className="pagination mb-0">
                    {/* Previous Button */}
                    <li className={`page-item ${!prevPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handlePreviousPage} disabled={!prevPageUrl}>
                        Previous
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {renderPageNumbers()}

                    {/* Next Button */}
                    <li className={`page-item ${!nextPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handleNextPage} disabled={!nextPageUrl}>
                        Next
                        </button>
                    </li>
                    </ul>
                </nav>
                {/* <div className="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div> */}
            </div>
            </>
            }
            <Footer/>
        </main>
        </>

    );
}
export default DriverList;